module.exports = __webpack_public_path__ + "img/xiang@2x.ecccbf24.png";